import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getLoadBalancers = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
       Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/loadbalancers.json`, settings);
}

export const getLoadBalancersDetails = async (apiUrl, LbId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/${LbId}`, settings);
}

export const getLoadBalancerFlavors = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/flavors?sort=name:desc`, settings);
}

export const createLoadBalancer = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.post(`${apiUrl}/v2.0/lbaas/loadbalancers`, data, settings);
}

export const deleteLoadBalancer = async (apiUrl, loadBalancerId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.delete(`${apiUrl}/v2.0/lbaas/loadbalancers/${loadBalancerId}?cascade=true`, settings);
}

export const updateLoadBalancer = async (apiUrl, loadBalancerId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.put(`${apiUrl}/v2.0/lbaas/loadbalancers/${loadBalancerId}`, data, settings);
}

// Listener
export const getLBListeners = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/listeners`, settings);
}

export const createLBListener = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.post(`${apiUrl}/v2.0/lbaas/listeners/`, data, settings);
}

// Pool
export const getLBPools = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/pools`, settings);
}

export const createLBPool = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.post(`${apiUrl}/v2.0/lbaas/pools/`, data, settings);
}

// Member
export const getLBMembers = async (apiUrl, poolId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/pools/${poolId}/members`, settings);
}

export const getMemberDetails = async (apiUrl, memberId, poolId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/pools/${poolId}/members/${memberId}`, settings);
}

export const createLBMember = async (apiUrl, data, poolId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.post(`${apiUrl}/v2.0/lbaas/pools/${poolId}/members`, data, settings);
}

export const deleteLBMember = async (apiUrl, memberId, poolId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.delete(`${apiUrl}/v2.0/lbaas/pools/${poolId}/members/${memberId}`, settings);
}

// Monitor
export const getLBMonitors = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.get(`${apiUrl}/v2.0/lbaas/healthmonitors`, settings);
}

export const createLBMonitor = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.post(`${apiUrl}/v2.0/lbaas/healthmonitors`, data, settings);
}

export const deleteLBMonitor = async (apiUrl, monitorId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.delete(`${apiUrl}/v2.0/lbaas/healthmonitors/${monitorId}`, settings);
}

export const updateLBMonitor = async (apiUrl, monitorId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  return axios.put(`${apiUrl}/v2.0/lbaas/healthmonitors/${monitorId}`, data, settings);
}
